import type { JSONValue } from "../models/Json";
import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const init = async () => {
  return httpRequest.get("/prt/pub/general/init");
};

export const check = async (data: Record<string, JSONValue>) => {
  return httpRequest.get("/prt/pub/general/init", data);
};

export const register = async (data: Record<string, JSONValue>) => {
  return httpRequest.post("/prt/pub/partner", data);
};

// 200 { sent: true } (also for an unknown pair); 429 { code, message, retryAfter } when the send limit is hit.
export const resendRegisterCode = async (data: { verifyId: string; email: string }) => {
  return httpRequest.post("/prt/pub/partner/register/resend", data);
};
